var path = 'app/scripts/modules/core/src/pipeline/config/health/stagePlatformHealthOverrideCheckbox.directive.html';
var html = "<stage-config-field label=\"Task Completion\" ng-if=\"vm.application.attributes.platformHealthOnlyShowOverride\">\n  <platform-health-override command=\"vm.stage\"\n                            platform-health-type=\"vm.platformHealthType\">\n  </platform-health-override>\n</stage-config-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/health/stagePlatformHealthOverrideCheckbox.directive.html
// module id = 1060
// module chunks = 0